import { useBooleanFlag } from '@trm/feature-flags/web';
import Loadable from '~/components/LoadableErrorReload';
import NotFound from '~/pages/maintenance/404';
import { PagePolicies } from '~/utils/roles';

import { restrictPage } from './restrictPage';

const PurchaseOrdersPage = Loadable(() => import('~/pages/dashboard/admin/purchase-orders'));

function PurchaseOrdersFlagRoute() {
  return useBooleanFlag('admin-purchase-orders', false) ? <PurchaseOrdersPage /> : <NotFound />;
}

export const purchaseOrdersRoute = {
  path: 'purchase-orders',
  element: restrictPage(<PurchaseOrdersFlagRoute />, PagePolicies.AdminTransactionsPage),
};
